/**
 * Generic object pool to reuse game entities instead of allocating new ones every frame.
 * Usage: pool.get(...args) returns a recycled (or new) object with reset(...args) called.
 *        pool.release(obj) returns the object to the pool for later reuse.
 *        pool.releaseAll(arr) bulk-releases an array of objects.
 */
export class Pool {
    constructor(createFn) {
        this.createFn = createFn;
        this._pool = [];
    }

    /** Retrieve an object from the pool (or create a new one) and reset it. */
    get(...args) {
        const obj = this._pool.length > 0 ? this._pool.pop() : this.createFn();
        obj.reset(...args);
        return obj;
    }

    /** Return an object to the pool for future reuse. */
    release(obj) {
        this._pool.push(obj);
    }

    /** Bulk-release all objects in an array back to the pool. */
    releaseAll(arr) {
        for (let i = 0; i < arr.length; i++) {
            this._pool.push(arr[i]);
        }
    }

    get poolSize() {
        return this._pool.length;
    }
}
